import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { Badge } from '../Badge';
const DEFAULT_YEAR = new Date().getFullYear();
type Props = {
  award: string;
  year?: number;
};
export function SummaryTableRoundupBanner(t0) {
  const $ = _c(10);
  const {
    award,
    year: t1
  } = t0;
  const year = t1 === undefined ? DEFAULT_YEAR : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: "0.5rem",
      md: "1rem"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "absolute",
      top: 0,
      display: "flex",
      flexWrap: "nowrap",
      width: "fit-content",
      "--boa-gap-between-elements": t2,
      maxHeight: "var(--best-of-awards-height-summary-table)",
      "--best-of-awards-ribbon-height": {
        xs: "1.65rem",
        md: "2rem"
      }
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      gap: "var(--boa-gap-between-elements)",
      backgroundColor: "greens.lightest",
      height: "var(--best-of-awards-ribbon-height)",
      paddingLeft: "var(--boa-gap-between-elements)"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Box sx={{
      display: {
        xs: "block",
        md: "none"
      }
    }}><Badge width={25.6} height={32} /></Box>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={{
      display: {
        xs: "none",
        md: "block"
      }
    }}><Badge /></Box>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: "1rem",
      md: "2rem"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      alignItems: "center",
      backgroundColor: "greens.lightest",
      minHeight: t7,
      paddingRight: "10px",
      "::after": {
        content: "\"\"",
        position: "absolute",
        right: "calc(var(--best-of-awards-ribbon-height) / 2 * -1)",
        top: 0,
        border: "calc(var(--best-of-awards-ribbon-height) / 2) solid",
        borderColor: "greens.lightest",
        borderLeftSize: 0,
        borderRight: "10px solid transparent"
      }
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== award || $[8] !== year) {
    t9 = <Box sx={t3}><Box sx={t4}>{t5}{t6}<Box sx={t8}><Typography variant="h6" component="span" color="primary.main" textTransform="uppercase" letterSpacing="0.6px" noWrap={true}>{year} {award}</Typography></Box></Box></Box>;
    $[7] = award;
    $[8] = year;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}